import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetConfiguration,
  SaveConfiguration,
  GetConfigurations,
  AddNewConfiguration,
  DeleteConfiguration,
  CopyConfiguration,
  ExportConfigurations,
  ImportConfigurations,
  GetFARCalculationType,
  LocaliseConfiguration,
};

function GetConfigurations(
  contractId,
  versionId,
  editionId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/editions/${editionId}/mindestlohn/configuration`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetConfiguration(
  contractId,
  versionId,
  editionId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/editions/${editionId}/mindestlohn/configuration/${editionId}`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetFARCalculationType(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(process.env.VUE_APP_BASE_API_URL + `/farcalculationtypes`, headers)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      console.log(error);
      onError(error);
    });
}

function SaveConfiguration(
  contractId,
  versionId,
  editionId,
  configuration,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/editions/${editionId}/mindestlohn/configuration`,
      configuration,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function AddNewConfiguration(
  contractId,
  versionId,
  editionId,
  configuration,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/editions/${editionId}/mindestlohn/configuration`,
      configuration,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function CopyConfiguration(
  contractId,
  versionId,
  editionId,
  configurationId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/editions/${editionId}/mindestlohn/configuration/${configurationId}/clone`,
      null,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function DeleteConfiguration(
  contractId,
  versionId,
  editionId,
  configurationId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/editions/${editionId}/mindestlohn/configuration/${configurationId}`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function ExportConfigurations(
  contractId,
  versionNumber,
  editionId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionNumber}/editions/${editionId}/export/minimumwage`,
      { ...headers, responseType: "blob" },
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function ImportConfigurations(
  contractId,
  versionNumber,
  editionId,
  overwrite,
  sourceData,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionNumber}/editions/${editionId}/import/minimumwage?overwrite=${overwrite}`,
      sourceData,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function LocaliseConfiguration(
  contractId,
  versionId,
  editionId,
  configurationId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/editions/${editionId}/mindestlohn/configuration/${configurationId}/localise`,
      null,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}